module.exports = __webpack_public_path__ + "static/media/clinician-watchman-preview.a861509f.jpg";